<template>
	<div class="page-container flex-centerize flex-column">
		<InstallationContent
			v-bind="$attrs"
			v-on="$listeners"
			:forceInstall="forceInstall"
			:installableId="installableId"
			:avoidRedirection="avoidRedirection"
		/>
		<AppDialogManager />
	</div>
</template>

<script>
import InstallationContent from './InstallationContent';
import AppDialogManager from '@/components/dialogs/AppDialogManager/AppDialogManager';

export default {
	name: 'Installation',
	props: {
		installableId: { type: String },
		forceInstall: { type: Boolean },
		avoidRedirection: { type: Boolean },
	},
	components: { AppDialogManager, InstallationContent },
};
</script>
<style lang="scss" scoped>
.page-container {
	width: 100vw;
	height: 100vh;
}
</style>
